import React from 'react';
import Text from '../Text/index';
import { CareersValuesCarouselSection } from './styles';
import Slider from 'react-slick';
import { Col } from 'antd';
import rightArrow from 'images/right-arrow-white.svg';
import leftArrow from 'images/left-arrow-white.svg';

const CareersValuesCarousel = ({ slideOneImg, slideTwoImg, slideThreeImg, ...otherProps }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    nextArrow: <img src={rightArrow} />,
    prevArrow: <img src={leftArrow} />,
  };

  return (
    <CareersValuesCarouselSection {...otherProps}>
      <Text
        type={'h2'}
        alignDesktop={'center'}
        size={'28px'}
        className="careers--underlined-heading"
        id="ourvalues"
      >
        Values
      </Text>
      <div className="careers--values-carousel-container">
        <Slider {...settings}>
          <div className="careers--value-item-container">
            <div className="careers--values-item-wrap">
              <div
                className="careers--value-image"
                style={{ backgroundImage: 'url(' + slideOneImg + ')' }}
              ></div>
            </div>
            <div className="careers--values-item-wrap">
              <div className="careers--values-copy-container">
                <Text type={'p'} className="careers--values-kicker">
                  For customers and Titans
                </Text>
                <Text type={'h3'} className="careers--values-heading">
                  Change Lives
                </Text>
                <ul className="careers--values-body">
                  <li>We obsess over making customers successful</li>
                  <li>We are the innovators of our destiny</li>
                  <li>We lead with gratitude</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="careers--value-item-container">
            <div className="careers--values-item-wrap">
              <div
                className="careers--value-image"
                style={{ backgroundImage: 'url(' + slideTwoImg + ')' }}
              ></div>
            </div>
            <div className="careers--values-item-wrap">
              <div className="careers--values-copy-container">
                <Text type={'p'} className="careers--values-kicker">
                  Dream big and act quickly
                </Text>
                <Text type={'h3'} className="careers--values-heading">
                  Achieve the Extraordinary
                </Text>
                <ul className="careers--values-body">
                  <li>We hold extraordinary standards</li>
                  <li>We think and behave as owners</li>
                  <li>We are relentless in the pursuit of our goals</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="careers--value-item-container">
            <div className="careers--values-item-wrap">
              <div
                className="careers--value-image"
                style={{ backgroundImage: 'url(' + slideThreeImg + ')' }}
              ></div>
            </div>
            <div className="careers--values-item-wrap">
              <div className="careers--values-copy-container">
                <Text type={'p'} className="careers--values-kicker">
                  We can’t do it alone
                </Text>
                <Text type={'h3'} className="careers--values-heading">
                  Be a Dream Team
                </Text>
                <ul className="careers--values-body">
                  <li>We trust and care for one another and ourselves</li>
                  <li>At ServiceTitan, trust is given and must be honored</li>
                  <li>We are inclusive</li>
                </ul>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </CareersValuesCarouselSection>
  );
};

export default CareersValuesCarousel;
